// eslint-disable-next-line
declare let window: any
export function PlaceInAkixiNameSpace<T>(key: string, value: T): void {
    // eslint-disable-next-line
    window.com = window.com || {}
    // eslint-disable-next-line
    window.com.Akixi = window.com.Akixi || {}
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    window.com.Akixi[key] = value
}

export function PlaceInNestedAkixiNameSpace<T>(namespace: string, key: string, value: T): void {
    // eslint-disable-next-line
    window.com = window.com || {}
    // eslint-disable-next-line
    window.com.Akixi = window.com.Akixi || {}
    // eslint-disable-next-line
    window.com.Akixi[namespace] = window.com.Akixi[namespace] || {}
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    window.com.Akixi[namespace][key] = value
}

export function PlaceInGlobalNameSpace<T>(key: string, value: T): void {
    // eslint-disable-next-line
    window[key] = value
}

export function PlaceInNestedGlobalNameSpace<T>(namespace: string, key: string, value: T): void {
    // eslint-disable-next-line
    window[namespace] = window[namespace] || {}
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    window[namespace][key] = value
}

export function arrayFromMapIterator<V>(map: Map<string, V>): Array<V> {
    const arr: V[] = []

    map.forEach((entry) => arr.push(entry))

    return arr
}
